import {
  ADVISOR_NOTE_FIELD_PREFIX,
  advisorNotePageDisplayNames,
  type PdfAdvisorNotePage,
  type PdfSectionScope,
} from "@repo/shared/types";
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useUserLanguage } from "@/lib/i18n/context";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./advisor-note-menu-items.i18n";

type AdvisorNoteMenuItemsProps = {
  pages: PdfAdvisorNotePage[];
  sectionScope?: PdfSectionScope;
  /** `label` reads "Advisor note – Classification"; `field` is the reference to insert. */
  onInsert: (label: string, field: string) => void;
};

export function AdvisorNoteMenuItems({ pages, sectionScope, onInsert }: AdvisorNoteMenuItemsProps) {
  const { userLanguage } = useUserLanguage();
  const t = useT(T);
  const inGoalContext = sectionScope === "per_goal" || sectionScope === "per_portfolio";
  const offered = pages.filter((page) => page.pageType === "global" || inGoalContext);
  if (offered.length === 0) return null;
  // Named over the whole list, so an entry reads the same in every section.
  const names = advisorNotePageDisplayNames(pages, userLanguage);

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>{t.advisorNotes}</DropdownMenuLabel>
      <DropdownMenuGroup>
        {offered.map((page) => {
          const name = names.get(page.id) ?? page.name;
          const label = t.advisorNote(name);
          return (
            <DropdownMenuItem
              key={page.id}
              onClick={() => onInsert(label, `${ADVISOR_NOTE_FIELD_PREFIX}${name}`)}
            >
              {label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuGroup>
    </>
  );
}
